<template>
<div>
    <div style="display: flex; flex-direction: column; height: 100vh">
        <div v-if="updateAvailable" class="alert alert-warning m-0 text-center" style="flex: 0 0 48px">
            Update available. Please <a href="#" @click.prevent="pageReload()" class="alert-link  font-weight-bold">refresh the page</a> when not on a call.
        </div>

        <div style="display: flex; flex-grow: 1">
            <div style="width: 50px; height: 100vh; background: #201c3b; color: white; font-size: 20px; text-align: center; padding-top: 20px; flex-shrink: 0">

                <img :src="url('css/recruiter/tr_logo.png')" style="width: 40px; margin-bottom: 30px;">

                <router-link v-if="data.user_role === 'Administrator' && data.display_campaigns" to="/admin/driver-engage/fulfillment" class="d-block t2t-layout-icon my-3">
                    <i class="fas fa-file-invoice"></i>
                </router-link>

                <hr>

                <div class="t2t-layout-icon my-3">
                    <i class="fa-fw fas fa-briefcase" style="cursor: pointer;" @click.prevent="accounts()" title="Accounts"></i>
                </div>
                <div class="t2t-layout-icon my-3">
                    <i class="fa-fw fas fa-headset" style="cursor: pointer;" @click.prevent="jobadviser()" title="JobAdviser"></i>
                </div>
                <div class="t2t-layout-icon my-3">
                    <i class="fas fa-sign-out-alt" style="cursor: pointer;" @click.prevent="logout()" title="Log Out"></i>
                </div>
            </div>

            <router-view 
                :data="data"
                ref="routerView"
            ></router-view>
        </div>
    </div>
</div>
</template>

<style>
    .t2t-inner-box {
        border-bottom: 1px solid #e1e1e1;
        padding: 10px 20px;
    }
    .t2t-border-bottom {
        border-bottom: 1px solid #e1e1e1;
    }
    .t2t-gbg {
        background: #fafafa;
    }

    .t2t-layout-icon {
        color: #fff;
    }
    .t2t-layout-icon:hover {
        color: #dadada;
    }
    .ui-wrapper {
        display: flex; flex-direction: column; overflow: auto; flex-grow: 1; height: 100%; background: rgb(250, 250, 250);
    }
    .ui-inner-box {
        padding: 10px 20px;
    }
    .ui-container-bordered {
        padding: 10px 20px;
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
        background: white;
        height: 100%;
    }

    /*global styles*/
    .el-dropdown-menu__item {
        padding: 10px;
    }
</style>

<script>
    export default {
        props: [
            'masterData',
            'appJsHash'
        ],
        data() {
            return {
                data: Object.assign(this.masterData, {
                    detailPage: null,
                    detailData: null,
                    candidateList: {
                        tab: 'all',
                        filters: {},
                        orderBy: {
                            column: 'last_message',
                            direction: 'desc',
                        },
                        pagination: {
                            currentPage: 1,
                            lastPage: null,
                            startRecords: null,
                            endRecords: null,
                            totalRecords: null,
                            perPage: 100,
                        },
                    },
                    listConversations: [],
                    spinner: {
                        searching: false
                    }
                }),

                // tabLastUpdate: [],
                lastUpdate: null,

                // call disposition
                show_call_disposition: false,
                current_call: null,

                updateAvailable: false
            }
        },
        methods: {
            accounts() {
                window.location.href = url('/admin/employers');
            },
            jobadviser() {
                window.location.href = url('/jas/call-screen');
            },
            logout() {
                window.location.href = url('/logout');
            },

            checkAppJsHash() {
                axios.get(url(`app-js-hash.txt?${new Date().getTime()}`)).then(response => {
                    if(this.appJsHash != response.data && response.data != "local") {
                        this.updateAvailable = true;
                    }
                });
            },
            pageReload() {
                location.reload(true);
            },
        },
        mounted() {
            // Check if app.js is still current
            setInterval(() => {
                this.checkAppJsHash();
            }, 120000);
            setTimeout(() => {
                this.checkAppJsHash();
            }, 1000);

            sessionStorage.instanceId = Math.random();
        }
    }
</script>
